// Undo / redo: snapshots of the canvas markup (editor marks included, transient states excluded).

export class History {
    constructor(limit = 100) {
        this.limit = limit;
        this.stack = [];
        this.index = -1;
    }

    /** Records a state; returns false when it equals the current one. */
    push(state) {
        const current = this.stack[this.index];
        if (current && current.html === state.html) {
            current.selection = state.selection;
            return false;
        }
        this.stack = this.stack.slice(0, this.index + 1);
        this.stack.push(state);
        if (this.stack.length > this.limit) this.stack.shift();
        this.index = this.stack.length - 1;
        return true;
    }

    /** Replaces the current state (first load, or after an import that should not be undone). */
    reset(state) {
        this.stack = [state];
        this.index = 0;
    }

    canUndo() {
        return this.index > 0;
    }

    canRedo() {
        return this.index < this.stack.length - 1;
    }

    undo() {
        if (!this.canUndo()) return null;
        this.index -= 1;
        return this.stack[this.index];
    }

    redo() {
        if (!this.canRedo()) return null;
        this.index += 1;
        return this.stack[this.index];
    }
}

/** Position of a node as child indexes from the root, to find it again after a restore. */
export function pathOf(node, root) {
    const path = [];
    let current = node;
    while (current && current !== root) {
        const parent = current.parentNode;
        if (!parent) return null;
        path.unshift(Array.prototype.indexOf.call(parent.children, current));
        current = parent;
    }
    return current === root ? path : null;
}

export function nodeAt(path, root) {
    if (!path) return null;
    let current = root;
    for (const index of path) {
        current = current && current.children[index];
    }
    return current && current !== root ? current : null;
}
